import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Aviso de versión nueva.
 *
 * Se avisa y se espera, en vez de recargar solo. Recargar sin preguntar
 * mientras alguien está cargando un trabajo en el campo le borra lo que estaba
 * escribiendo, y encima sin explicación: la pantalla simplemente se vacía. El
 * ahorro de un toque no vale eso.
 */
export function ActualizacionDisponible() {
  const {
    needRefresh: [hayVersionNueva, setHayVersionNueva],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      // Que no se pueda registrar no rompe nada: la aplicación sigue andando
      // con red. Lo que no puede es fallar en silencio absoluto.
      console.warn('No se pudo registrar el service worker', error);
    },
  });

  if (!hayVersionNueva) return null;

  return (
    <div
      className="flex items-center justify-between gap-3 bg-[var(--accion)] px-4 py-3 text-sm text-[var(--sobre-accion)]"
      role="status"
      data-testid="aviso-actualizacion"
    >
      <span>Hay una versión nueva de la aplicación.</span>
      <div className="flex shrink-0 gap-2">
        <button
          type="button"
          onClick={() => setHayVersionNueva(false)}
          className="min-h-11 px-2 underline opacity-80"
        >
          Después
        </button>
        <button
          type="button"
          onClick={() => void updateServiceWorker(true)}
          className="min-h-11 rounded-[var(--radius-control)] bg-[var(--superficie)] px-3 font-medium text-[var(--tinta)]"
          data-testid="aplicar-actualizacion"
        >
          Actualizar
        </button>
      </div>
    </div>
  );
}
